import {listVans,deleteVan,addVan,fetchVan} from './vans.api';
import {  useQuery,useQueryClient,useMutation  } from '@tanstack/react-query';
export const useVans = ({ filters, page, perPage }) => {
    return useQuery({
      queryKey: ['vans', filters, page, perPage],
      queryFn: () => listVans({ filters, page, perPage }),
      keepPreviousData: true,
      /*staleTime: 5 * 60 * 1000, */
    });
  };
export const useDeleteVan = () => {
const queryClient = useQueryClient();
return useMutation({
    mutationFn: async (id) => deleteVan({id}),
    onSuccess: () => {
    queryClient.invalidateQueries({ queryKey: ['vans'] });
    },
});
};

export const useAddVan = () => {
  return useMutation({
    mutationFn: addVan,
  });
};

export const useFetchVan = (id) => {
  return useQuery({
    queryKey: ['van', id],
    queryFn: fetchVan,
    enabled: !!id
  });
};


  
